<sn-edit-organization-form
  [isLoading]="isLoading"
  [name]="channel.displayName"
  [publicity]="channel.publicity"
  [hideSystemNotifications]="channel.hideSystemNotifications"
  (send)="onDialogSent($event)"
>
</sn-edit-organization-form>
